import { createList, populateListFromReportConfig, populateListFromSearch } from '../../apis/lists';
// @ts-expect-error Untyped dependency
import getReportFilters from '../../public/get-report-filters';
import { getOrConvertToObjectTypeId } from '../../crmObjects/tsUtils';
import { USE_REPORT_CONFIG_TO_CREATE_LIST } from '../../constants/gates';
import { getReportConfig } from '../../report/configReportGetters';
const addObjectsToList = (report, listId, objectTypeId) => {
  const filterGroups = getReportFilters(report.get('config'));
  return populateListFromSearch(listId, objectTypeId, filterGroups);
};
const addObjectsToListWithReportConfig = (report, listId) => {
  return populateListFromReportConfig(listId, getReportConfig(report));
};
export default ((type, report, listNameOrId, gates) => {
  const objectTypeId = getOrConvertToObjectTypeId(report.get('config'));
  const useReportConfig = gates && gates.includes(USE_REPORT_CONFIG_TO_CREATE_LIST);
  if (type === 'new' && typeof listNameOrId === 'string') {
    return createList(listNameOrId, objectTypeId).then(response => {
      const listId = response.listId;
      return useReportConfig ? addObjectsToListWithReportConfig(report, listId) : addObjectsToList(report, listId, objectTypeId);
    });
  } else {
    const listId = +listNameOrId;
    return useReportConfig ? addObjectsToListWithReportConfig(report, listId) : addObjectsToList(report, listId, objectTypeId);
  }
});